import React, {Component} from 'react'
import {Documents} from './Documents'
import Typography from '@material-ui/core/Typography'
import {FormattedMessage} from 'react-intl'

export class SupportingDocuments extends Component {
  static defaultProps = {
    name: 'account.steps.documents',
  }

  render = () =>
    <Documents {...this.props} tag={this.props.context.registeredFor}>
      <Typography variant="subtitle1" style={{margin: '-50px 0 20px 0'}}>
        <FormattedMessage id="help.supported_upload_file_types" />
      </Typography>
      <Typography>
        <FormattedMessage id="account.steps.documents.instructions" />
      </Typography>
    </Documents>
}